/*
 * File: ProviderOfficeFeeFormModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 12/26/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Form model for the provider, office, and fee schedule fields
 */
const ProviderOfficeFeeFormModel = [
  {
    name: "accountProvider",
    label: "Account Provider",
    type: "select",
    options: [],
    required: true
  },
  {
    name: "patientProvider",
    label: "Patient Provider",
    type: "select",
    options: []
  },
  {
    name: "patientOffice",
    label: "Office",
    type: "select",
    options: []
  },
  {
    name: "feeSchedule",
    label: "Fee Schedule",
    type: "select",
    options: []
  }
];

export default ProviderOfficeFeeFormModel;
